import { DEFAULT_LOCALE, locales } from '@spotify-internal/s4mp-shared';
import appConfig from '../../apps.config';

export const getUrlParts = (path: string) => {
  const basePaths = Object.keys(appConfig).map(val => val.replace('/', ''));
  const parts = path.match(
    new RegExp(
      `^\/?(${basePaths.join('|')})?(?:$|(?:\/?(${locales.join(
        '|',
      )})?(?:$|\/(.*)?)))`,
    ),
  );
  return {
    locale: (parts && parts[2]) || DEFAULT_LOCALE,
    basePath: parts && parts[1],
    path: parts && parts[3],
  };
};
